// @flow
import { ConfSurveysActionTypes } from './constants';

type ConfSurveysAction = { type: string, payload: {} | string };

// common success
export const confSurveysApiResponseSuccess = (actionType: string, data: any): ConfSurveysAction => ({
    type: ConfSurveysActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const confSurveysApiResponseError = (actionType: string, error: string): ConfSurveysAction => ({
    type: ConfSurveysActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getConfSurvey = (confSurveyId, destination): ConfSurveysAction => ({
    type: ConfSurveysActionTypes.GET_CONF_SURVEY,
    payload: { confSurveyId, destination },
});

export const updateConfSurvey = (confSurvey: any): ConfSurveysAction => ({
    type: ConfSurveysActionTypes.UPDATE_CONF_SURVEY,
    payload: confSurvey
})

export const resetConfSurveys = (): ConfSurveysAction => ({
    type: ConfSurveysActionTypes.RESET,
    payload: {},
});

